import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "../errors";
import routes from "./routes";

// This should never render as all throwing components are rendered within a more meaningful error boundary.
// Minimal effort has gone into displaying this error. It's here "just in case" for debugging purposes.
const renderAppFallback = (props: { error: Error }) => (
  <code>{Error.prototype.toString.call(props.error)}</code>
);

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <ErrorBoundary fallback={renderAppFallback}>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}
